import { render, staticRenderFns } from "./CDRStatisticsResume.vue?vue&type=template&id=07963cb6"
import script from "./CDRStatisticsResume.vue?vue&type=script&lang=ts"
export * from "./CDRStatisticsResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports